import React, { useState } from "react";
import styled from "@emotion/styled";
import Divider from "@material-ui/core/Divider";

import Drawer from "@material-ui/core/Drawer";
import Typography from "@material-ui/core/Typography";
import { useStoreon } from "storeon/react";
import ShareIcon from "@material-ui/icons/Share";
import CloseIcon from "@material-ui/icons/Close";
import LinearProgress from "@material-ui/core/LinearProgress";
import IconButton from "@material-ui/core/IconButton";

import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { Summery } from "comp/productselector/Summery";

import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  EmailIcon,
  FacebookIcon,
  PinterestIcon,
  TwitterIcon,
} from "react-share";

import ToolbarButton from "components/ToolbarButton";
import { shareDesign } from "api";

const Content = styled.div({
  padding: 10,
  maxWidth: 370,
});

const ShareButtonsWrapper = styled.div({
  display: "flex",
  justifyContent: "space-between",
  padding: 20,
});

const ProductTitle = styled(Typography)({
  fontWeight: 600,
  marginTop: 20,
});

const DesignPreview = styled.img({
  width: 350,
  border: "1px solid gray",
  margin: "20px auto",
  magrinBottom: 0
});

const Header = styled.div({
  display: "flex",
  justifyContent: "space-between",
  "> p": {
    color: "#888",
    fontWeight: 600,
    fontSize: 18,
  },
  "> svg": {
    color: "#888",
    cursor: "pointer",
  },
});

const Share = () => {
  const { dispatch, canvas, product, proboCodes, productOptions } = useStoreon(
    "canvas",
    "product",
    "proboCodes",
    "productOptions"
  );
  const [isOpen, setIsOpen] = useState(false);
  const [shareData, setShareData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const productId = product?.id;
  const productTitle = product?.title;
  const sku = !product?.SKU ? '' :  `SKU: ${product.SKU}`;

  const share = async () => {
    setIsLoading(true);
    const canvasData = canvas.DPE.persistent.toBase64();
    try {
      const shareData = await shareDesign(productId, canvasData, proboCodes);
      setShareData(shareData);
    } catch (err) {
      dispatch("notification/error", err.message);
      setIsOpen(false);
    }
    setIsLoading(false);
  };
  const { protocol, hostname } = window.location;
  const shareUrl = `${protocol}//${hostname}/dpeditor/?design=${shareData?.url}`;

  return (
    <React.Fragment>
      <ToolbarButton
        dark
        active={isOpen}
        onClick={() => {
          setIsOpen(true);
          share();
        }}
        vertical
        icon={<ShareIcon style={{ fontSize: 27 }} />}
      />

      <Drawer
        anchor="right"
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          setTimeout(() => setShareData(undefined), 1000);
        }}
        onClosed
      >
        <Content>
          <Header>
            <Typography>Share</Typography>
            <CloseIcon onClick={() => setIsOpen(false)} />
          </Header>
          <Divider style={{ minWidth: 350, marginLeft: -10 }} />

          {isLoading && <LinearProgress />}

          {(!isLoading || !shareData) && (
            <React.Fragment>
              <ProductTitle>{`${productTitle} ${sku}`}</ProductTitle>
              <DesignPreview src={shareData?.thumbnail} alt="shared" />
              <Summery proboOptions={productOptions} product={product} />
              <Input
                id="dpeshareinput"
                value={shareUrl}
                readOnly
                fullWidth
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        const copyText = document.getElementById(
                          "dpeshareinput"
                        );
                        copyText.select();
                        copyText.setSelectionRange(0, 99999);
                        document.execCommand("copy");
                        dispatch(
                          "notification/info",
                          `Url copied to clipboard`
                        );
                      }}
                    >
                      {<FileCopyIcon />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <ShareButtonsWrapper>
                <EmailShareButton url={shareUrl}>
                  <EmailIcon size={48} round={true} />
                </EmailShareButton>
                <FacebookShareButton url={shareUrl}>
                  <FacebookIcon size={48} round={true} />
                </FacebookShareButton>
                <TwitterShareButton url={shareUrl}>
                  <TwitterIcon size={48} round={true} />
                </TwitterShareButton>
                <PinterestShareButton url={shareUrl}>
                  <PinterestIcon size={48} round={true} />
                </PinterestShareButton>
              </ShareButtonsWrapper>
            </React.Fragment>
          )}
        </Content>
      </Drawer>
    </React.Fragment>
  );
};

export default Share;
